module.exports = __webpack_public_path__ + "img/sv16.2e5ffc2b.svg";